// types
import {
  NewItemDataDetermine,
  DataGridRef,
  UpdateInitSetupdata
} from './types';

export const getDgInstance = (dataGridRef: DataGridRef) =>
  dataGridRef.current.instance;

const getNewItemData = ({
  dataGridRef,
  rowKey,
  key,
  value
}: NewItemDataDetermine) => {
  const dgInstance = getDgInstance(dataGridRef);

  const getVisibleRowsData = () =>
    dgInstance.getVisibleRows().map((e) => e.data);

  const item = getVisibleRowsData().find((x) => x[key] === rowKey);
  const newItemData = { ...item, ...value };

  return newItemData;
};

const beforeAfterHandlers = (dataGridRef: DataGridRef) => {
  const dgInstance = getDgInstance(dataGridRef);

  return {
    before: dgInstance.beginCustomLoading,
    after: dgInstance.endCustomLoading
  };
};

export const updateRemoteInit = <TPatchResData>({
  patchFn,
  dataGridRef,
  onPatchSuccess,
  key
}: UpdateInitSetupdata<TPatchResData>) => (
  rowKey: string | number,
  value: any
) => {
  const { before, after } = beforeAfterHandlers(dataGridRef);

  const newItemData: unknown = getNewItemData({
    dataGridRef,
    rowKey,
    key,
    value
  });

  before('');

  return new Promise((resolve, reject) => {
    patchFn(newItemData)
      .then(({ data }) => {
        if (onPatchSuccess) {
          return onPatchSuccess({ data, resolve: () => resolve(null) });
        }

        return resolve(null);
      })
      .catch(reject)
      .finally(after);
  });
};
